import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TableColumnHeader, TableRow, Text } from "shared/components/Spor";

type TrainStopHeaderProps = {};

// undefined = auto
export const headerWidths = [40, undefined, 50, 100, 100];
const getWidthPx = (index: number) =>
  headerWidths[index] ? `${headerWidths[index]}px` : undefined;

export const TrainStopHeader: FC<TrainStopHeaderProps> = () => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableColumnHeader width={getWidthPx(0)} />
      <TableColumnHeader width={getWidthPx(1)}>
        <Text variant="xs" fontWeight={400}>
          {t("Stasjon")}
        </Text>
      </TableColumnHeader>
      <TableColumnHeader width={getWidthPx(2)}>
        <Text variant="xs" fontWeight={400}>
          {t("Spor")}
        </Text>
      </TableColumnHeader>
      <TableColumnHeader width={getWidthPx(3)}>
        <Text variant="xs" fontWeight={400}>
          {t("Ankomst")}
        </Text>
      </TableColumnHeader>
      <TableColumnHeader width={getWidthPx(4)}>
        <Text variant="xs" fontWeight={400}>
          {t("Avgang")}
        </Text>
      </TableColumnHeader>
    </TableRow>
  );
};
